import React, { useContext, useRef, useEffect } from "react";
import Main from "../../Main/components";
import { APPLICATION_NAME, MAIN_ID } from "../../util/constants";
import {
  withOSUTheming,
  useScrollToHash,
  Mui,
  withTableOfContents,
  withDarkMode,
  withPageHeading,
  PageHeadingContext,
  useFooterWithTOC
} from "@osu/react-ui";
import { AppProvider } from "../context";
import { Navbar as OSUNavBar } from "@osu/navbar";
import Footer from "@osu/footer";
import Navbar from "../../Navbar/components";
import useCssVariableUpdater from "../hooks/useCssVariableUpdater";
import useCompleteAuthFlowHandler from "../../Authentication/hooks/useCompleteAuthFlowHandler";
import '../styles/index.scss'
import AlertProvider from "../../Common/components/AlertProvider";
import useAlert from "../../Common/components/AlertProvider/useAlert";
import { setAlertFunction } from "../../services/graphql/alertMiddleware";

function App(props = {}) {
  const { navHeight, darkMode } = props;
  const { ref } = useScrollToHash();
  const { setApplicationName } = useContext(PageHeadingContext);
  const footerRef = useRef()
  useFooterWithTOC({ ref: footerRef })
  const trigger = Mui.useScrollTrigger({
    disableHysteresis: true,
    threshold: navHeight,
  });

  const { showAlert } = useAlert();

  useEffect(() => {
    if (showAlert)
      setAlertFunction(showAlert);
  }, [showAlert]);

  useEffect(() => {
    setApplicationName(APPLICATION_NAME);
  }, [setApplicationName]);

  return (
    <div className="App" ref={ref}>
      <OSUNavBar darkMode={darkMode} />
      <Navbar />
      <Main spacingTop={!trigger} className="anchor-link" id={MAIN_ID} />
      <Footer darkMode={darkMode} ref={footerRef} />
    </div>
  );
}

const TOCWrappedApp = withTableOfContents(App);

function Provider(props = {}) {
  const { darkMode } =
    props;
  const { navHeight } = useCssVariableUpdater({ darkMode });
  

  useCompleteAuthFlowHandler()

  return (
    <AppProvider value={{ darkMode }}>
      <AlertProvider>
        <TOCWrappedApp darkMode={darkMode} navHeight={navHeight} />
      </AlertProvider>
    </AppProvider>
  );
}

export default withDarkMode(
  withOSUTheming(withPageHeading(Provider))
);
